import { createState } from "states/createState";

export const { listState, currentIdState, itemState } = createState<FigureView>(
  { name: "figure", getId: ({ _id }) => _id }
);
